import * as React from 'react'
import {
  Button,
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Tooltip,
} from '@material-ui/core'
import ThumbsUpDownIcon from '@material-ui/icons/ThumbsUpDown'
import ThumbUpIcon from '@material-ui/icons/ThumbUp'
import ThumbDownIcon from '@material-ui/icons/ThumbDown'
import EditIcon from '@material-ui/icons/Edit'
import CloseIcon from '@material-ui/icons/Close'
import { useState } from 'react'
import _ from 'lodash'
import { postReviewSocialMediaPost } from 'services/consultApi'
import reportError from 'utils/errorReporter'
import { toast } from 'react-toastify'
import { useSelector } from 'react-redux'
import { personAvatarForChip } from 'ui/components/PersonAvatar'
import { BR_DATE_TIME_FORMAT, dateToStr } from 'utils/constants/dateConstants'
import styles from './styles'

const SocialMediaPostReviewButton = ({ post, reviewButtonsVisibility, onUpdatePost }) => {
  const [comment, setComment] = useState(post.snippet?.review?.comment)
  const [analysisDialogOpen, setAnalysisDialogOpen] = useState(false)
  const [editMode, setEditMode] = useState(_.isEmpty(post.snippet?.review))
  const userId = useSelector((state) => state.auth.sub)
  const apiKey = useSelector((state) => state.auth.api_key)

  const classes = styles()

  const decisions = {
    approved: {
      label: 'Aprovado',
      color: 'green',
      icon: <ThumbUpIcon style={{ color: 'green' }} className={classes.doneButtonIconMarked} />,
    },
    reproved: {
      label: 'Reprovado',
      color: 'red',
      icon: <ThumbDownIcon style={{ color: 'red' }} className={classes.doneButtonIconMarked} />,
    },
  }

  const performReview = async (decision) => {
    const { snippet } = post

    let res = null
    try {
      res = await postReviewSocialMediaPost(apiKey, userId, post.request_id, snippet.request_id, decision, comment)
    } catch (err) {
      reportError(err, 'Erro ao revisar postagem')
      return null
    }
    toast.success(`Análise ${post.review ? 'atualizada' : 'enviada'} com sucesso!`)

    setAnalysisDialogOpen(false)
    setEditMode(false)

    onUpdatePost(post, res.data)

    return null
  }

  const handleChangeDescription = (event) => {
    const text = event.target.value
    setComment(text)
  }

  const showReviewField = () => {
    const buttonsDisabled = _.isEmpty(comment)

    return (
      <React.Fragment>
        <div>
          <TextField
            fullWidth
            multiline
            rows={7}
            value={comment}
            onChange={handleChangeDescription}
            InputLabelProps={{
              shrink: true,
            }}
            placeholder="Motivo da decisão"
          />
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div className={classes.buttonsDiv}>
            <Button
              disabled={buttonsDisabled}
              variant="contained"
              onClick={() => performReview('approved')}
              startIcon={<ThumbUpIcon />}
            >
              Aprovar
            </Button>

            <Button
              disabled={buttonsDisabled}
              variant="contained"
              onClick={() => performReview('reproved')}
              startIcon={<ThumbDownIcon />}
            >
              Reprovar
            </Button>
          </div>
          {post.snippet?.review && (
            <div className={classes.buttonsDiv}>
              <Button disabled={buttonsDisabled} variant="contained" onClick={() => setEditMode(false)}>
                Cancelar
              </Button>
            </div>
          )}
        </div>
      </React.Fragment>
    )
  }

  const showReviewData = (reviewData) => {
    const decision = decisions[reviewData?.decision]

    if (!decision) {
      return null
    }

    return (
      <div style={{ marginTop: 15, display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
        <div>
          <strong>Situação:</strong>
          {' '}
          <strong style={{ color: decision.color }}>{decision.label}</strong>
        </div>

        <div>
          <strong>Analisado por:</strong>
          {' '}
          <span>{reviewData.reviewer_name}</span>
        </div>


        <div>
          <strong>Analisado em:</strong>
          {' '}
          <span>{reviewData.created_at}</span>
        </div>

        {reviewData.created_at !== reviewData.updated_at && (
        <div>
          <strong>Última alteração:</strong>
          {' '}
          <span>{reviewData.updated_at}</span>
        </div>
)}

        <br />

        <div>
          <strong>Motivo da decisão:</strong>
          <p>{reviewData.comment}</p>
        </div>

        <div className={classes.buttonsDiv}>
          <Button variant="contained" startIcon={<EditIcon />} onClick={() => setEditMode(true)}>
            Editar
          </Button>
        </div>
      </div>
    )
  }

  const personName = post?.snippet?.person_name
  const review = post?.snippet?.review
  const hasReview = !_.isEmpty(review)
  const createdAt = post?.snippet?.created_at

  const buttonIcon = () => {
    if (!hasReview) {
      return <ThumbsUpDownIcon className={hasReview ? classes.doneButtonIconMarked : classes.doneButtonIconUnMarked} />
    }

    return decisions[review.decision]?.icon
  }
  return (
    <React.Fragment>
      <Tooltip
        arrow
        placement="right"
        title={<h3>{hasReview ? 'Exibir análise' : 'Analisar postagem de rede social'}</h3>}
      >
        <span>
          <IconButton
            style={{
              display: reviewButtonsVisibility[post.link] || hasReview || 'none',
            }}
            size="small"
            onClick={() => setAnalysisDialogOpen(true)}
          >
            {buttonIcon()}
          </IconButton>
        </span>
      </Tooltip>
      <Dialog open={analysisDialogOpen} onClose={() => setAnalysisDialogOpen(false)}>
        <DialogTitle>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>Analisar postagem em mídia social</div>
            <IconButton
              aria-label="close"
              onClick={() => setAnalysisDialogOpen(false)}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent>
          <div className={classes.textField}>
            <div>
              {personName && (
                <div>
                  <h4>Envolvido(a):</h4>
                  <Chip
                    style={{ marginTop: 5 }}
                    avatar={personAvatarForChip(personName)}
                    label={personName}
                  />
                </div>
              )}

              <br />
              <div>
                <h4>Título:</h4>
                <p>{post.title}</p>
              </div>

              <br />

              <div>
                <h4>Trecho:</h4>
                <p>{post.snippet.description}</p>
              </div>

              <br />

              <div>
                <h4>Link:</h4>
                <a href={post.link}>{post.link}</a>
              </div>

              <br />

              { createdAt && (
              <div>
                <h4>Postagem identificada em:</h4>
                <p>{dateToStr(createdAt, BR_DATE_TIME_FORMAT)}</p>
              </div>
) }

              <br />
            </div>

            <br />
            <hr />
            <br />

            <h3>Revisão</h3>
            {editMode ? showReviewField() : showReviewData(post.snippet.review)}
          </div>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  )
}

export default SocialMediaPostReviewButton
